import API from '../api/axios';
import { fetchWithCache } from '../utils/apiCache';

/**
 * Fetches TTS audio for the given text in the given language.
 *
 * @param {string} text - Text to convert to speech
 * @param {string} lang - Language code (e.g. 'mr-IN', 'hi-IN', 'en-IN')
 * @param {boolean} translate - Whether the backend should translate the text first (default: false)
 */
export const getTTSAudio = async (text, lang, translate = false) => {
    // Use first 150 chars for a stable, collision-resistant cache key
    const cacheKey = `tts_${lang}_${translate}_${text.substring(0, 150)}`;
    return fetchWithCache(cacheKey, async () => {
        const response = await API.get('/api/tts', {
            params: { text, lang, translate },
            responseType: 'blob'
        });
        return response.data;
    }, 10 * 60 * 1000); // 10-minute cache
};

/**
 * Translates text to the target Indian language via backend.
 * Results are cached for 1 hour to avoid repeated API calls.
 *
 * @param {string} text - English source text
 * @param {string} lang - Target language code (e.g. 'mr-IN', 'hi-IN')
 * @returns {{ translatedText: string }}
 */
export const translateText = async (text, lang) => {
    // Use first 150 chars for stable key; lang change is the primary differentiator
    const cacheKey = `translation_${lang}_${text.substring(0, 150)}`;
    return fetchWithCache(cacheKey, async () => {
        const { data } = await API.get('/api/tts/translate', {
            params: { text, lang }
        });
        return data;
    }, 60 * 60 * 1000); // 1-hour cache — translations don't change
};
